import './shortcode.scss';

function scrollToGfConfirmation(root = document) {
	const confirmation = root.querySelector
		? root.querySelector('.gform_confirmation_wrapper') ||
		  (root.classList?.contains('gform_confirmation_wrapper') ? root : null)
		: document.querySelector('.gform_confirmation_wrapper');

	if (!confirmation) return;

	const target = confirmation.closest('.shortcode') || confirmation;
	target.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

document.addEventListener('DOMContentLoaded', () => {
	scrollToGfConfirmation();

	// AJAX confirmations replace the form in-place — watch for them and scroll.
	const observer = new MutationObserver((mutations) => {
		for (const mutation of mutations) {
			for (const node of mutation.addedNodes) {
				if (!(node instanceof HTMLElement)) continue;
				if (
					node.classList.contains('gform_confirmation_wrapper') ||
					node.querySelector?.('.gform_confirmation_wrapper')
				) {
					scrollToGfConfirmation(node);
					return;
				}
			}
		}
	});

	observer.observe(document.body, { childList: true, subtree: true });
});
